import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { desgloseCarrito, fmt } from '../utils/igv';
import Receipt from '../components/Receipt';

export default function CartPage() {
  const { cart, updateCartQty, removeFromCart, clearCart, settings, loadAll, updateCartItem } = useApp();
  const [showReceipt, setShowReceipt] = useState(false);
  // índice del item cuyo peso se está editando, null = ninguno
  const [editingWeightIdx, setEditingWeightIdx] = useState(null);
  const [weightInput, setWeightInput] = useState('');

  // Recalcular carrito respetando total_override para items por peso con monto fijo
  const cartAdjusted = cart.map(item => {
    if (item.by_weight && item.total_override) {
      return { ...item, price: item.total_override, qty: 1 };
    }
    return item;
  });
  const { subtotal, igv, total } = desgloseCarrito(cartAdjusted);

  const handleCheckout = async () => {
    try {
      await fetch('/api/sales', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: cart.map(i => ({
            id: i.id, qty: i.qty, name: i.name,
            price: i.price, price_per_kg: i.price_per_kg,
            unit: i.unit, by_weight: i.by_weight ? 1 : 0,
          })),
          total,
          subtotal,
          igv,
          cashier: settings?.cashier || '',
        }),
      });
    } catch (_) {}
    setShowReceipt(true);
  };

  const handleNewSale = () => {
    loadAll();
    clearCart();
    setShowReceipt(false);
  };

  const openWeightEdit = (i) => {
    setEditingWeightIdx(i);
    setWeightInput(String(cart[i].qty));
  };

  const confirmWeight = () => {
    const kg = parseFloat(weightInput.replace(',', '.'));
    if (!isNaN(kg) && kg > 0) {
      // qty guarda los kg; price_per_kg guarda precio base por kg
      const item = cart[editingWeightIdx];
      const pricePerKg = item.price_per_kg || item.price;
      // Actualizamos qty=kg y recalculamos el precio total del ítem
      updateCartItem(editingWeightIdx, { qty: kg, price: pricePerKg });
    }
    setEditingWeightIdx(null);
    setWeightInput('');
  };

  if (showReceipt) {
    return (
      <Receipt
        cart={cart}
        settings={settings}
        onClose={() => setShowReceipt(false)}
        onNewSale={handleNewSale}
      />
    );
  }

  return (
    <div style={S.wrap}>
      <div style={S.hdr}>
        <h2 style={S.title}>Carrito de venta</h2>
        {cart.length > 0 && (
          <button style={S.clearBtn} onClick={clearCart}>Limpiar</button>
        )}
      </div>

      {/* Items list */}
      <div style={S.list}>
        {cart.length === 0 ? (
          <div style={S.empty}>
            <span style={{ fontSize: 48 }}>🛒</span>
            <p style={{ color: 'var(--t1)', marginTop: 12 }}>El carrito está vacío</p>
            <p style={{ color: 'var(--t2)', fontSize: 12, marginTop: 4 }}>
              Toca + en cualquier producto para agregar
            </p>
          </div>
        ) : (
          cart.map((item, i) => (
            <div key={item.id + '_' + i} style={S.item}>
              <div style={S.itemImg}>
                {item.image_url
                  ? <img src={item.image_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 8 }}/>
                  : <span style={{ fontSize: 22 }}>{item.emoji || '📦'}</span>
                }
              </div>
              <div style={S.itemInfo}>
                <p style={S.itemName}>{item.name}</p>
                {item.by_weight ? (
                  <p style={S.itemSub}>
                    {fmt(item.price_per_kg || item.price)}/kg ×{' '}
                    <button style={S.weightBtn} onClick={() => openWeightEdit(i)}>
                      ⚖️ {parseFloat(item.qty.toFixed(3))} kg
                    </button>
                  </p>
                ) : (
                  <p style={S.itemSub}>{fmt(item.price)} × {item.qty} {item.unit}</p>
                )}
              </div>

              {item.by_weight ? (
                /* Para productos por peso: solo botón de editar peso y eliminar */
                <div style={S.weightActions}>
                  <button style={S.editWeightBtn} onClick={() => openWeightEdit(i)}>
                    Editar peso
                  </button>
                </div>
              ) : (
                /* Para productos normales: controles +/- */
                <div style={S.qtyCtrl}>
                  <button style={S.qBtn} onClick={() => updateCartQty(i, -1)}>−</button>
                  <span style={S.qNum}>{item.qty}</span>
                  <button style={S.qBtn} onClick={() => updateCartQty(i, +1)}>+</button>
                </div>
              )}

              <span style={S.itemTotal}>
                {fmt(item.by_weight
                  ? (item.price_per_kg || item.price) * item.qty
                  : item.price * item.qty
                )}
              </span>
              <button style={S.delBtn} onClick={() => removeFromCart(i)}>🗑</button>
            </div>
          ))
        )}
      </div>

      {/* Totals + IGV breakdown */}
      {cart.length > 0 && (
        <div style={S.footer}>
          <div style={S.igvBox}>
            <div style={S.igvRow}>
              <span style={S.igvLbl}>Operaciones gravadas (sin IGV)</span>
              <span style={S.igvVal}>{fmt(subtotal)}</span>
            </div>
            <div style={S.igvRow}>
              <span style={S.igvLbl}>IGV 18%</span>
              <span style={S.igvVal}>{fmt(igv)}</span>
            </div>
          </div>
          <div style={S.totalRow}>
            <span>Total</span>
            <span style={S.totalAmt}>{fmt(total)}</span>
          </div>
          <button style={S.checkoutBtn} onClick={handleCheckout}>
            🖨️ Cobrar e imprimir comprobante
          </button>
        </div>
      )}

      {/* Modal edición de peso */}
      {editingWeightIdx !== null && (
        <div style={S.modalOverlay} onClick={() => setEditingWeightIdx(null)}>
          <div style={S.modalBox} onClick={e => e.stopPropagation()}>
            <p style={{ fontSize: 16, fontWeight: 700, marginBottom: 4 }}>
              ⚖️ {cart[editingWeightIdx]?.name}
            </p>
            <p style={{ fontSize: 12, color: 'var(--t1)', marginBottom: 14 }}>
              Precio: {fmt(cart[editingWeightIdx]?.price_per_kg || cart[editingWeightIdx]?.price)} / kg
            </p>
            <label style={S.modalLabel}>Peso en kg</label>
            <input
              style={S.modalInput}
              type="number"
              step="0.001"
              min="0.001"
              placeholder="Ej: 0.450"
              value={weightInput}
              onChange={e => setWeightInput(e.target.value)}
              autoFocus
            />
            {weightInput && !isNaN(parseFloat(weightInput.replace(',','.'))) && parseFloat(weightInput.replace(',','.')) > 0 && (
              <div style={S.modalPreview}>
                Total: <strong>{fmt((cart[editingWeightIdx]?.price_per_kg || cart[editingWeightIdx]?.price) * parseFloat(weightInput.replace(',','.')))}</strong>
              </div>
            )}
            <div style={{ display:'flex', gap:10, marginTop:16 }}>
              <button style={S.modalCancel} onClick={() => setEditingWeightIdx(null)}>Cancelar</button>
              <button style={S.modalConfirm} onClick={confirmWeight}>✓ Confirmar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const S = {
  wrap:         { display: 'flex', flexDirection: 'column', height: '100%' },
  hdr:          { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 14px 8px', flexShrink: 0 },
  title:        { fontSize: 20, fontWeight: 800 },
  clearBtn:     { background: 'rgba(231,76,60,.1)', color: 'var(--err)', border: '0.5px solid rgba(231,76,60,.25)', borderRadius: 8, padding: '6px 12px', fontSize: 12 },
  list:         { flex: 1, overflowY: 'auto', padding: '0 14px', scrollbarWidth: 'none' },
  empty:        { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '70%', textAlign: 'center' },
  item:         { display: 'flex', alignItems: 'center', gap: 10, padding: '11px 0', borderBottom: '0.5px solid var(--bd)' },
  itemImg:      { width: 48, height: 48, background: 'var(--bg2)', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, overflow: 'hidden' },
  itemInfo:     { flex: 1, minWidth: 0 },
  itemName:     { fontSize: 13, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  itemSub:      { fontSize: 11, color: 'var(--t1)', marginTop: 2 },
  weightBtn:    { background: 'rgba(255,184,0,.15)', border: '0.5px solid rgba(255,184,0,.4)', borderRadius: 5, padding: '1px 6px', fontSize: 11, color: '#f0b400', cursor: 'pointer' },
  weightActions:{ display: 'flex', alignItems: 'center', flexShrink: 0 },
  editWeightBtn:{ background: 'rgba(255,184,0,.12)', border: '0.5px solid rgba(255,184,0,.35)', borderRadius: 7, padding: '5px 9px', fontSize: 11, color: '#f0b400', cursor: 'pointer', whiteSpace: 'nowrap' },
  qtyCtrl:      { display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 },
  qBtn:         { background: 'var(--bg2)', border: '0.5px solid var(--bd2)', borderRadius: 6, width: 28, height: 28, fontSize: 17, color: 'var(--t0)', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  qNum:         { fontSize: 14, fontWeight: 700, minWidth: 22, textAlign: 'center' },
  itemTotal:    { fontSize: 14, fontWeight: 700, color: 'var(--acc)', minWidth: 58, textAlign: 'right', flexShrink: 0 },
  delBtn:       { background: 'rgba(231,76,60,.1)', border: '0.5px solid rgba(231,76,60,.2)', borderRadius: 6, width: 28, height: 28, fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  footer:       { padding: '12px 14px', borderTop: '0.5px solid var(--bd)', flexShrink: 0 },
  igvBox:       { background: 'var(--bg2)', borderRadius: 10, padding: '10px 12px', marginBottom: 10, border: '0.5px solid var(--bd2)' },
  igvRow:       { display: 'flex', justifyContent: 'space-between', marginBottom: 4 },
  igvLbl:       { fontSize: 12, color: 'var(--t1)' },
  igvVal:       { fontSize: 12, color: 'var(--t0)', fontWeight: 500 },
  totalRow:     { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 },
  totalAmt:     { fontSize: 22, fontWeight: 800, color: 'var(--acc)' },
  checkoutBtn:  { width: '100%', background: 'var(--acc)', color: '#fff', border: 'none', borderRadius: 12, padding: 14, fontSize: 15, fontWeight: 800 },
  // Modal peso
  modalOverlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.75)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200, padding: 20 },
  modalBox:     { background: 'var(--bg1)', borderRadius: 16, padding: 22, width: '100%', maxWidth: 320, border: '0.5px solid var(--bd2)' },
  modalLabel:   { display: 'block', fontSize: 10, color: 'var(--t1)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: .4, marginBottom: 6 },
  modalInput:   { width: '100%', background: 'var(--bg2)', border: '1.5px solid var(--acc)', borderRadius: 10, padding: '12px 14px', color: 'var(--t0)', fontSize: 22, fontWeight: 700, textAlign: 'center' },
  modalPreview: { marginTop: 10, textAlign: 'center', fontSize: 14, color: 'var(--t1)' },
  modalCancel:  { flex: 1, background: 'var(--bg2)', color: 'var(--t1)', border: '0.5px solid var(--bd)', borderRadius: 10, padding: 12, fontSize: 14 },
  modalConfirm: { flex: 2, background: 'var(--acc)', color: '#fff', border: 'none', borderRadius: 10, padding: 12, fontSize: 14, fontWeight: 700 },
};
